module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("“As we shall see, there is also considerable historical evidence of enormous networks of underground tunnels in both North, South and Central America, but it is not my intention to discuss the facts here, for that would preclude some of the conclusions I have reached concerning them, to which I shall come in later chapters.”")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Alec Maclellan, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Lost World of Agharti")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0